'use client';
import type {
  ProductListV2,
  ProductMembership,
} from '@lib/types/api/ProductListV2';
import { createContext, useContext } from 'react';

export type { ProductInfo } from './productListsHelpers';

export type ProductListsContextValue = {
  personalLists: ProductListV2[];
  orgLists: ProductListV2[];
  defaultList: ProductListV2 | null;
  isLoading: boolean;
  isProductInList: (productId: string) => boolean | null;
  toggleProductList: (product: { id: string; name: string }) => void;
  openCreateListModal: () => void;
  onChangeList: (product: { id: string; name: string }) => void;
  fetchProductMembership: (productId: string) => Promise<ProductMembership>;
  fetchBatchProductMembership: (productIds: string[]) => Promise<void>;
};

export const ProductListsContext =
  createContext<ProductListsContextValue | null>(null);

const DEFAULT_CONTEXT: ProductListsContextValue = {
  personalLists: [],
  orgLists: [],
  defaultList: null,
  isLoading: false,
  isProductInList: () => null,
  toggleProductList: () => undefined,
  openCreateListModal: () => undefined,
  onChangeList: () => undefined,
  fetchProductMembership: () =>
    Promise.resolve({ personal: [], organization: [] }),
  fetchBatchProductMembership: () => Promise.resolve(),
};

export const useProductLists = () => {
  const context = useContext(ProductListsContext);
  return context ?? DEFAULT_CONTEXT;
};
